import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetAccrualBalancesByEmployeeRequestSchema,
  TGetAccrualBalancesByEmployeeResponseSchema,
} from "./getAccrualBalancesByEmployee.schema";

export const getAccrualBalancesByEmployee = (axios: IAxiosInstance) => {
  return async ({
    companyID,
    employeeID,
  }: TGetAccrualBalancesByEmployeeRequestSchema) => {
    const { data } = await axios.noRetry.get<
      IApiResponse<TGetAccrualBalancesByEmployeeResponseSchema>
    >(`/accrual-policies/balances/employee/${employeeID}`, {
      params: { companyID },
    });

    if (data.success) {
      return data.data;
    }

    throw new Error("Something went wrong");
  };
};
